import { useQuery } from "@tanstack/react-query";
import {
	type GetLastTurnedRollsParams,
	getLastTurnedRollsData,
} from "../repositories/LastTurnedRollsRepository";

type UseLastTurnedRollsParams = Omit<GetLastTurnedRollsParams, "signal">;

export const useLastTurnedRolls = ({
	start,
	end,
}: UseLastTurnedRollsParams) => {
	return useQuery({
		queryKey: ["lastTurnedRolls", start, end],
		queryFn: ({ signal }) => getLastTurnedRollsData({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
